import React, { useState, useRef } from "react";
import "./AddPrescriptionForm.css";
import axios from "axios";
import { motion } from "framer-motion";
import Webcam from "react-webcam";
import gif from '../../Assets/Banner/whatsapp.gif';
import check from '../../Assets/Brands/check.gif'
import {
  FaTimes,
  FaCamera,
  FaUpload,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaPrescription,
  FaWhatsapp,
  FaCheck
} from "react-icons/fa";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { BiSend } from "react-icons/bi";

const AddPrescriptionForm = ({ onClose }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [stream, setStream] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const webcamRef = useRef(null);

  const whatsappNumber = "9118063939";
  
  const allowedFileTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf'
  ];

  const startCamera = () => {
    setShowCamera(true);
  };

  const stopCamera = () => {
    setShowCamera(false);
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      fetch(imageSrc)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "camera-capture.jpg", {
            type: "image/jpeg",
          });
          setImage(file);
          setPreviewUrl(imageSrc);
          stopCamera();
        });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!allowedFileTypes.includes(file.type)) {
        setError('Invalid file type. Only images (JPEG, PNG)');
        return;
    }

    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
    setError('');
  };

  const removeImage = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setImage(null);
    setPreviewUrl("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const shareOnWhatsApp = () => {
    console.log("WhatsApp sharing disabled for 'Upload Here' option");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (!image) {
      setError("Please upload a prescription file");
      setLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("image", image);

      setShowSuccessAnimation(true);
      setSuccess("Prescription uploaded successfully!");

      axios.post(
        "https://api.swasthmitra.com/api/prescription/add",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then(response => {
        console.log("Upload completed successfully");
      }).catch(err => {
        console.error("Background upload error:", err);
      });
      
      setTimeout(() => {
        setName("");
        setPhone("");
        setImage(null);
        setPreviewUrl("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setShowSuccessAnimation(false);
        onClose();
      }, 5000);
    } catch (err) {
      console.error("Synchronous error:", err);
      setError("An error occurred while uploading");
      setShowSuccessAnimation(false);
    } finally {
      setLoading(false);
    }
  };

  const videoConstraints = {
    width: 720,
    height: 480,
    facingMode: "environment",
  };

  return (
    <motion.div
      className="add-prescription-form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="modal-overlay">
        <motion.div
          className={`modal-content ${showSuccessAnimation ? 'success-state' : ''}`}
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
        >
          {!showSuccessAnimation && (
            <motion.button
              className="close-btn1"
              onClick={onClose}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              X
            </motion.button>
          )}

          {showSuccessAnimation ? (
            <motion.div
              className="success-popup-container"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.4 }}
            >
              <div className="success-popup-content">
                <div className="success-icon-wrapper">
                  <img src={check} alt="Success" className="success-animation-gif" />
                  <div className="success-icon-backdrop"></div>
                </div>
                
                <motion.h3
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                  className="success-popup-title"
                >
                  Prescription Uploaded Successfully!
                </motion.h3>
                
                <motion.p
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.3 }}
                  className="success-popup-message"
                >
                  Our team will contact you shortly with your order details
                </motion.p>
                
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.4, duration: 0.3 }}
                  className="success-popup-actions"
                >
                  {/* <button 
                    onClick={onClose}
                    className="success-popup-button"
                  >
                    Close
                  </button> */}
                </motion.div>
              </div>
            </motion.div>
          ) : (
            <>
              <div className="form-header">
                <motion.h2
                  initial={{ y: -20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.1 }}
                >
                  <span style={{fontWeight:'bold',fontFamily:'Poppins,sans-serif'}}>"डॉo की पर्ची यहाँ अपलोड करें"</span>
                </motion.h2>
                <motion.p
                  initial={{ y: -10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                > (
                  <span style={{fontSize:'13px', color:'black',fontWeight:'600' }}> What's App / Camera </span>
                  <span style={{fontSize:'13px', color:'black' }}>
                  आइकन पर क्लिक करें, डॉक्टर की पर्ची की साफ़ फोटो लें, नाम व मोबाइल नंबर भरें और फॉर्म सबमिट करें - हमारे प्रतिनिधि तुरंत आपसे संपर्क करेंगे। </span>
                )
                </motion.p>
              </div>

              {error && (
                <motion.div
                  className="alert error"
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                >
                  <FaTimes /> {error}
                </motion.div>
              )}

              {success && !showSuccessAnimation && (
                <motion.div
                  className="alert success"
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                >
                  <FaPrescription /> {success}
                </motion.div>
              )}


        <div className="whats-icon">
  <a
    href="https://wa.me/7007512120"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#C22928", textDecoration: "none" }}
  >
    <img className="whatsapp_img" src={gif} alt="WhatsApp" />
  </a>
</div>
              <form onSubmit={handleSubmit}>
                <motion.div
                  className="image-upload-section"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  {!previewUrl && !showCamera && (
                    <motion.div
                      className=""
                      whileHover={{ scale: 1.01, borderColor: "#6366f1" }}
                    >
                      <div className="">
                        <motion.div
                          className=""
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        > 
                    
                          
                          <label htmlFor="file-upload" className="upload-here">
                            <span style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'10px'}}><FaCamera /> Upload Here</span>
                          </label>
                          
                          <input
                            id="file-upload"
                            type="file"
                            onChange={handleFileChange}
                            accept="image/jpeg, image/png, image/gif, image/webp, application/pdf"
                            ref={fileInputRef}
                            className="file-input"
                          />
                        </motion.div>
                      </div>
                    </motion.div>
                  )}

                  {showCamera && (
                    <div className="camera-container">
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                        className="camera-preview"
                      />
                      <div className="camera-buttons">
                        <motion.button
                          type="button"
                          className="capture-btn"
                          onClick={captureImage}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <MdOutlineAddAPhoto /> Capture Photo
                        </motion.button>
                        <motion.button
                          type="button"
                          className="cancel-btn"
                          onClick={stopCamera}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                        >
                          <FaTimes /> Cancel
                        </motion.button>
                      </div>
                    </div>
                  )}

                  {previewUrl && (
                    <motion.div
                      className="image-preview"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                    >
                      {image?.type === 'application/pdf' ? (
                        <div className="pdf-preview">
                          <FaPrescription size={48} />
                          <p>{image.name}</p>
                        </div>
                      ) : (
                        <img src={previewUrl} alt="Preview" />
                      )}
                      <motion.button
                        type="button"
                        className="remove-image"
                        onClick={removeImage}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        X
                      </motion.button>
                      {/* Removed WhatsApp share button when using "Upload Here" option */}
                    </motion.div>
                  )}
                </motion.div>

                <motion.div
                  className="form-fields"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                >
                  <div className="input-group">
                    <FaUser className="input-icon" />
                    <input
                      type="text"
                      placeholder="Your Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-group">
                    <FaPhone className="input-icon" />
                    <input
                      type="tel"
                      placeholder="Phone Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
                </motion.div>

                <motion.button
                  type="submit"
                  className="submit-btn"
                  disabled={loading}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  {loading ? (
                    <div className="loading-spinner" />
                  ) : (
                    <>
                      Submit
                    </>
                  )}
                </motion.button>
              </form>
            </>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AddPrescriptionForm;